import { createFileRoute } from '@tanstack/react-router';

import { requireRoute } from '@/router/guards';
import InstallerDashboard from '@/ui/pages/Installer/InstallerDashboard/InstallerDashboard';
import { installerDashboardSearchSchema } from '@/ui/pages/Installer/InstallerDashboard/installerDashboardSearch';

// HS-1634: the Installer workspace's landing page — the caller's current job(s).
export const Route = createFileRoute('/_dashboard/installer/')({
  validateSearch: installerDashboardSearchSchema,
  beforeLoad: requireRoute('/installer'),
  component: InstallerDashboard,
});
